import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 50px',
    backgroundColor: theme.palette.whitePepper.main,
  },

  itemContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '30px',

    [theme.breakpoints.down('sm')]: {
      columnGap: '15px',
    },
  },

  icon: {
    [theme.breakpoints.down('sm')]: {
      width: '60px',
      transform: 'scale(0.70)',
    },
  },
});
